import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconCheck from '../build/icon-check'

export const IconCheckComponent: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconCheck} />
}

export default IconCheckComponent
